import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';

import style from './style.scss';

const CloseButton = ({ className, onClick, varient }) => (
  <button
    type="button"
    aria-label="Close Button"
    onClick={onClick}
    className={clsx(style.close, className, { [style[varient]]: varient })}
  >
    <FontAwesomeIcon icon={faTimes} />
  </button>
);

export default CloseButton;
